<template>
  <section>
    <search1 :searchStatus="false" :back="'/home'"></search1>
    <section class="padding-footer">
      <b-container>
        <utilities-downtime></utilities-downtime>
      </b-container>
    </section>
    <!-- <MenuFooter /> -->
  </section>
</template>
<script lang="js">
import Vue from "vue";
import Search1 from "@/components/Search1.vue";
import { Component } from "vue-property-decorator";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import UtilitiesDowntime from "@/views/pages/Utilities/Modules/Downtime/Utilities-Downtime.vue";

@Component({
    components: {
        MenuFooter,
        Search1,
        UtilitiesDowntime,
    },
})
export default class Utilities extends Vue {
    getImgUrl(pet) {
        var images = require.context('@/assets/img', false, /\.svg$/);
        return images('./' + pet)
    }
}
</script>
